import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import Income from '@mui/icons-material/PlaylistAddCheck';
import { Prompt } from 'react-router-dom';
import { isValid } from '@totalsoft/pure-validations-react';
import ReportGeneralDataComponent from './ReportGeneralDataComponent';

const ReportGeneralDataCard = ({
  reportItem,
  onPropertyChanged,
  onSave,
  openModes,
  reportTypes,
  validation,
  partnerTypes,
  documentTypes
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={Income}
      iconColor='primary'
      title={t('Reports.GeneralData')}
      actions={
        <IconButton
          color='transparent'
          type='save'
          fontSize='medium'
          tooltip={t('Reports.Save')}
          onClick={onSave}
          disabled={!reportItem.changed || !(validation |> isValid)}
        />
      }
    >
      <Prompt when={reportItem.changed} message={t('Reports.LeavingWithoutSavingReport')} />
      <ReportGeneralDataComponent
        reportItem={reportItem}
        onPropertyChanged={onPropertyChanged}
        openModes={openModes}
        reportTypes={reportTypes}
        partnerTypes={partnerTypes}
        documentTypes={documentTypes}
        validation={validation}
      />
    </Card>
  );
};

ReportGeneralDataCard.propTypes = {
  reportItem: PropTypes.object.isRequired,
  openModes: PropTypes.array.isRequired,
  reportTypes: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  partnerTypes: PropTypes.array,
  documentTypes: PropTypes.array
};

export default ReportGeneralDataCard;
